"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHit = exports.isOccupied = exports.countAtPoint = exports.opponentPoint = exports.getPointsWithAtLeast = exports.getInitialBoard = exports.getInitialPoints = void 0;
exports.isReadyToBearOff = isReadyToBearOff;
exports.isOnBar = isOnBar;
exports.withMove = withMove;
const lodash_1 = require("lodash");
const Model_1 = require("./Model");
const constants_1 = require("./constants");
const players_1 = require("./players");
const getInitialPoints = () => ({
    [Model_1.OFF_POINT]: 0,
    6: 5,
    8: 3,
    13: 5,
    24: 2,
    [Model_1.BAR_POINT]: 0,
});
exports.getInitialPoints = getInitialPoints;
const getInitialBoard = () => ({
    [Model_1.WHITE]: (0, exports.getInitialPoints)(),
    [Model_1.BLACK]: (0, exports.getInitialPoints)(),
});
exports.getInitialBoard = getInitialBoard;
const getPointsWithAtLeast = (board, player, minCount) => {
    const points = [];
    for (let point = Model_1.BAR_POINT; point > Model_1.OFF_POINT; point--) {
        if ((0, exports.countAtPoint)(board, player, point) >= minCount) {
            points.push(point);
        }
    }
    // console.log('points', JSON.stringify(points, null, 4))
    return points;
};
exports.getPointsWithAtLeast = getPointsWithAtLeast;
const opponentPoint = (point) => Model_1.BAR_POINT - Number(point);
exports.opponentPoint = opponentPoint;
const countAtPoint = (board, player, point) => { var _a; return (_a = board[player][point]) !== null && _a !== void 0 ? _a : 0; };
exports.countAtPoint = countAtPoint;
// has more than one checker
const isOccupied = (board, player, point) => point !== Model_1.OFF_POINT &&
    point !== Model_1.BAR_POINT &&
    (0, exports.countAtPoint)(board, player, point) > 1;
exports.isOccupied = isOccupied;
const isHit = (board, player, move) => move.to !== Model_1.OFF_POINT &&
    move.to !== Model_1.BAR_POINT &&
    (0, exports.countAtPoint)(board, (0, players_1.opponent)(player), (0, exports.opponentPoint)(move.to)) === 1;
exports.isHit = isHit;
function isReadyToBearOff(board, player) {
    const playerPoints = (0, exports.getPointsWithAtLeast)(board, player, 1);
    return playerPoints.every((p) => p <= constants_1.HOME_BOARD_SIZE);
}
function isOnBar(board, player) {
    return (0, exports.countAtPoint)(board, player, Model_1.BAR_POINT) > 0;
}
function withMove(board, player, move) {
    var _a, _b, _c;
    const next = (0, lodash_1.cloneDeep)(board);
    const playerBoard = next[player];
    const fromCount = playerBoard[move.from];
    if (fromCount === undefined) {
        throw new Error(`No checker to move at point ${move.from}`);
    }
    playerBoard[move.from] = fromCount - 1;
    playerBoard[move.to] = ((_a = playerBoard[move.to]) !== null && _a !== void 0 ? _a : 0) + 1;
    if ((0, exports.isHit)(next, player, move)) {
        const oppBoard = next[(0, players_1.opponent)(player)];
        const oppPoint = (0, exports.opponentPoint)(move.to);
        oppBoard[oppPoint] = ((_b = oppBoard[oppPoint]) !== null && _b !== void 0 ? _b : 0) - 1;
        oppBoard[Model_1.BAR_POINT] = ((_c = oppBoard[Model_1.BAR_POINT]) !== null && _c !== void 0 ? _c : 0) + 1;
    }
    return cleanupBoard(next);
}
function cleanupBoard(board) {
    for (let i = 1; i < Model_1.BAR_POINT; i++) {
        if (board[Model_1.WHITE][i] === 0) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete board[Model_1.WHITE][i];
        }
        if (board[Model_1.BLACK][i] === 0) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete board[Model_1.BLACK][i];
        }
    }
    return board;
}
